import "./css/Schema.css";
import { Link } from "react-router-dom";

function Schema() {
    return (
        <section className="coming-soon">
            <h1>ScHema</h1>
            <br/>
            <p1>
            Tidens väktare arbetar fortfarande med att sammanställa tidslinjen. 
            Schemat blir tillgängligt här innan mottagningen börjar.
            Håll ögon och öron öppna.
            </p1>
            <br/>
            <p2>
            Under tiden <span className="viking-font">N0llan </span> väntar kan <span className="viking-font">N0llan </span> studera 
            <Link to="/N0llehandboken"> <span className="viking-font"> N0lleHanDbOken. </span> </Link>
            </p2>
            <br/>
            <p2> Om <span className="viking-font">N0llan</span> vill se när <span className="viking-font">N0llan </span> har lektioner och föreläsningar så kan <span className="viking-font">N0llan</span> klicka här för{" "}
             <a
                href="https://cloud.timeedit.net/liu/web/schema/riq70Q70Yp7ZQ1Q5ZZ7cQ6g562ZQ636y3061uQ9Ql9onYZ576X1c05660YgZq6Qo.html"
                target="_blank"
                rel="noopener noreferrer"
            >
                Biologi-<span className="viking-font">N0llan </span>
            </a>
            eller här för{" "}
             <a
                href="https://cloud.timeedit.net/liu/web/schema/riq70Q70Yp8ZQ1Q5ZZ7cQ6g562ZQ606y3060uQ9Ql9onYZ576X1c05660YgZq6Qo.html"
                target="_blank"
                rel="noopener noreferrer"
            >
                Kemi-<span className="viking-font">N0llan</span>.
            </a>
            
            </p2>

        </section>
    );
}

export default Schema;